import { render, staticRenderFns } from "./AddRemoveCredit.vue?vue&type=template&id=52cd5ed3"
import script from "./AddRemoveCredit.vue?vue&type=script&lang=js"
export * from "./AddRemoveCredit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports